import React from 'react';
import { IconLabel } from '@/Componentes';

export const AlunoNome = ({ value }) => {
	return (
		<IconLabel
			icon={<i className='fas fa-user-check' alt="suap icon" height={15} />}
			label={value || ''}
			iconEnabled={!!value}
			link={`https://suap.ifbaiano.edu.br/admin/edu/aluno/?curso_campus__diretoria__setor__uo=23&tab=tab_any_data3&q=${encodeURI(value)}`}
		/>
	);
};

export default AlunoNome;
